import { Text, View } from "@react-pdf/renderer";
import React, { useEffect, useState } from "react";
import { MONTHLY_CHARGES_COLUMNS, getMonthlyChargesTableRows } from "./Data";
import { addSpaceAfterLetter } from "../CostPlusContract";

const MonthlyCharges = ({ contractDetails, generatedTitles }) => {
  const [monthlyChargesRow, setMonthlyCharges] = useState([]);

  useEffect(() => {
    if (contractDetails) {
      const _monthlyCharges = getMonthlyChargesTableRows(contractDetails);
      setMonthlyCharges(_monthlyCharges);
    }
  }, [contractDetails]);

  return (
    <>
      <Text
        style={{
          marginTop: 15,
          fontFamily: "Helvetica-Bold",
        }}
      >
        l. MONTHLY CHARGES:
      </Text>

      {/* table */}
      <View
        style={{
          width: "100%",
          // border: 1,
          marginTop: 10,
          borderBottom: 1,
        }}
      >
        {/* titles */}
        <View
          style={{
            flexDirection: "row",
            width: "100%",
            borderTop: 0.5,
            borderBottom: 0.5,
            borderLeft: 1,
          }}
        >
          <View
            style={{
              // height: 40,
              backgroundColor: "#ddd",
              padding: 3,
              paddingVertical: 6,
              width: "5%",
              borderRight: 1,
              fontSize: 8,
              fontFamily: "Helvetica-Bold",
              alignItems: "center",
            }}
          >
            <Text style={{ textAlign: "center" }}>Sl NO.</Text>
          </View>
          {generatedTitles?.map((item, index) => (
            <View
              style={{
                // height: 40,
                backgroundColor: "#ddd",
                padding: 3,
                paddingVertical: 6,
                width: `${100 / generatedTitles.length}%`,
                borderRight: 1,
                fontSize: 8,
                fontFamily: "Helvetica-Bold",
                alignItems: "center",
              }}
              key={index}
            >
              <Text style={{ textAlign: "center" }}>{item?.col}</Text>
            </View>
          ))}
        </View>
        {/* rows */}
        {monthlyChargesRow?.map((item, index) => (
          <View
            key={index}
            style={{
              flexDirection: "row",
              borderTop: 0.5,
              borderBottom: 0.5,
              borderLeft: 1,
            }}
          >
            <View
              style={{
                padding: 3,
                width: "5%",
                borderRight: 1,
                fontSize: 8,
              }}
            >
              <Text style={{ textAlign: "center" }} break>
                {index + 1}
              </Text>
            </View>
            {generatedTitles?.map((head, headIndx) => (
              <View
                key={headIndx}
                style={{
                  paddingHorizontal: 3,
                  paddingVertical: 2,
                  width: `${100 / generatedTitles.length}%`,
                  borderRight: 1,
                  fontSize: 8,
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Text
                  style={{
                    textAlign: "center",
                    width: "100%",
                  }}
                  break
                >
                  {addSpaceAfterLetter(item[head?.title])}
                </Text>
              </View>
            ))}
          </View>
        ))}
      </View>
    </>
  );
};

export default MonthlyCharges;
